export default class Rotation {
  public x: number = 0;
  public y: number = 0;

  constructor(pitch: number, yaw: number) {
    this.x = pitch;
    this.y = yaw;
  }

  get pitch(): number {
    return this.x;
  }

  get yaw(): number {
    return this.y;
  }

  add(pt: Rotation): Rotation {
    return new Rotation(this.x + pt.x, this.y + pt.y);
  }

  div(pt: Rotation): Rotation {
    return new Rotation(this.x / pt.x, this.y / pt.y);
  }

  magnitude(): number {
    return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
  }
}
